import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from 'components/Typography';
import { FlashMessage } from 'components/FlashMessages';
import { Elements } from '@stripe/react-stripe-js';
import { getStripeFromAccountID } from 'domains/billing';
import { PaymentMethod } from '@stripe/stripe-js';
import { AppointmentPaymentInput } from './AppointmentPaymentInput';

type Props = {
  className?: string;
  errorStripeCode?: string;
  errorStripeDeclineCode?: string;
  errorMessage?: string;
  onCardChange?: () => void;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setPaymentMethod: React.Dispatch<React.SetStateAction<PaymentMethod | undefined>>;
  statusCode?: number;
  stripeAccountId: string;
  triedToSubmit: boolean;
};

export const AppointmentPayment: React.FC<Props> = ({
  className,
  errorStripeCode,
  errorStripeDeclineCode,
  errorMessage,
  setIsLoading,
  setPaymentMethod,
  statusCode,
  stripeAccountId,
  triedToSubmit,
  onCardChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <Heading level="h5" className="mb-16">
        {t('appointmentPayment.heading')}
      </Heading>

      <Paragraph>{t('appointmentPayment.description.chargeCovers')}</Paragraph>
      <Paragraph>{t('appointmentPayment.description.chargeNonRefundable')}</Paragraph>
      <Paragraph>{t('appointmentPayment.description.providePaymentDetails')}</Paragraph>

      <FlashMessage className="w-full mt-40 mb-40" variant="warning">
        {t('appointmentPayment.warningPayment')}
      </FlashMessage>

      {stripeAccountId && (
        <div>
          <Heading level="h8" className="mb-8 font-semibold">
            {t('appointmentPayment.cardDetails')}
          </Heading>
          <Elements stripe={getStripeFromAccountID(stripeAccountId)}>
            <AppointmentPaymentInput
              errorStripeCode={errorStripeCode}
              errorStripeDeclineCode={errorStripeDeclineCode}
              errorMessage={triedToSubmit ? errorMessage : undefined}
              onCardChange={onCardChange}
              setIsLoading={setIsLoading}
              setPaymentMethod={setPaymentMethod}
              statusCode={statusCode}
            />
          </Elements>
        </div>
      )}
    </div>
  );
};
